/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/
export * from './linker.js';
export * from './name-provider.js';
export * from './references.js';
export * from './scope.js';
export * from './scope-computation.js';
export * from './scope-provider.js';
//# sourceMappingURL=index.js.map